import {Model} from './filter/model';
import {KeyValueObject} from './filter/key-value-object';
import {Recommended} from './filter/recommended';
import {Popular} from './filter/popular';
import {Mileage} from './filter/mileage';

export class BasicFilter {
  model: Array<Model>;
  fuelType: Array<KeyValueObject>;
  priceFrom: Array<KeyValueObject>;
  priceTo: Array<KeyValueObject>;
  recommended: Array<Recommended>;
  popular: Array<Popular>;
  mileageRanges: Array<Mileage>;
}
